import React from "react";
import { withStyles, withTheme } from "@material-ui/core";
import { compose } from "recompose";
import { withUserProfile } from "../../../../../../userProfile/userProfileContext";
import Map, {
  Marker,
  MapConstant,
  MapControls,
} from "../../../../../../lib/Map";
import TerminalMarker from "../../../../../mapComponents/Markers/TerminalMarker";
import styles from "../styles";
import DrawingTools from "../../../common/DrawTools/DrawingTools";
import Events from "../../../../../../../src/utilities/EventEmitter";
import { withAppConfig } from "../../../../../../appConfigContext";
import DrawStyles from "../../../../../../lib/Map/Trimble/components/DrawStyles";
import drawConstant from "../../../common/DrawTools/DrawConstant";
class RouteMappingToolMAP extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      geoDataList: [],
      styleArray: [],
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      const geoJson = this.getExistingFeaturesGeoJSON();
      const styleArray = this.getStyleArray(geoJson);
      this.setState({
        geoDataList: geoJson,
        styleArray: DrawStyles(styleArray),
      });
    }
  }

  getStyleArray = (geoJson) => {
    const defaultColor = "#05A792";
    let styleArray;
    if (geoJson && geoJson.length) {
      styleArray = ["case"];
      geoJson.forEach((data) => {
        styleArray.push(["==", ["get", "user_class_id"], data.id]);
        styleArray.push(["get", "user_color"]);
      });
      styleArray.push(defaultColor);
    } else {
      styleArray = defaultColor;
    }
    return styleArray;
  };

  getExistingFeaturesGeoJSON = () => {
    return this.props.data.map((feature) => {
      return {
        id: feature.routeMappingId,
        type: "Feature",
        properties: {
          class_id: feature.routeMappingId,
          color: feature.color,
        },
        geometry: {
          type: "Polygon",
          coordinates: [feature.boundary],
        },
      };
    });
  };

  onScaleDrawingComplete = (feature, type) => {
    if (
      [
        MapConstant.DRAWING_EVENTS.CREATE,
        MapConstant.DRAWING_EVENTS.UPDATE,
      ].includes(type)
    ) {
      Events.emit(drawConstant.ROUTE_MAPPING_EVENTS.DRAWING_UPDATED, feature);
    } else if (type === "delete") {
      Events.emit(drawConstant.ROUTE_MAPPING_EVENTS.DRAWING_DELETED, feature);
    }
  };

  render() {
    const { classes, theme, configJSON } = this.props;
    const { location } = this.props.userData.userProfile.terminal;
    return (
      <div className={classes.mapStyle}>
        <Map
          zoom={11}
          initialCenter={location}
          center={location}
          mapId="RouteMappingToolMAP"
          mapTheme={theme.themeName}
          eventHub={this.props.eventHub}
          mapConfig={configJSON?.maps}
        >
          <Marker
            position={location}
            animation
            zIndex={1}
            forceUpdate={true}
            isActiveShipment={true}
          >
            <TerminalMarker
              data={this.props.userData.userProfile.terminal}
            ></TerminalMarker>
          </Marker>

          <MapControls
            controlOptions={{
              zoomControl: {
                position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
              },
              satelliteViewControl: {
                position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
              },
              reCenterMapControl: {
                position: MapConstant.CONTROL_POSITION.BOTTOM_RIGHT,
              },
            }}
          />

          <DrawingTools
            polygonOptions={{
              fillColor: theme.MapDrawingColor,
              strokeColor: theme.MapDrawingColor,
            }}
            geoDataList={this.state.geoDataList}
            styleArray={this.state.styleArray}
            eventHub={Events}
            featureIds={this.props.featureIds}
            onDrawingComplete={this.onScaleDrawingComplete}
          />
        </Map>
      </div>
    );
  }
}

export default compose(
  withStyles(styles),
  withUserProfile,
  withAppConfig,
  withTheme()
)(RouteMappingToolMAP);
